var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCirclePending = function SvgCirclePending(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4163 0.00477656 15.9952 3.5837 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM1.33335 7.99997C1.33335 11.6819 4.31812 14.6666 8.00002 14.6666C11.6802 14.6626 14.6626 11.6802 14.6667 7.99997C14.6667 4.31807 11.6819 1.3333 8.00002 1.3333C4.31812 1.3333 1.33335 4.31807 1.33335 7.99997Z",
    fill: "#FFC042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 7.92083L6.84185 10.32L11.1998 5.19995",
    stroke: "#FFC042",
    strokeWidth: 1.5
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCirclePending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle_pending.1960a940.svg";
export { ForwardRef as ReactComponent };